<template>
<div class="chapter">
<div class="inner_page">
<p class="publisheri"><img alt="image" src="images/title.png"/></p>
<p class="subtitle">ONE MOTHER’S DESPERATE QUEST</p>
<p class="subtitle1"><i>to Uncover What Was Really Wrong with Her Family...<br/>and</i> THE DISTURBING FACTS <i>She Revealed that Could</i></p>
<p class="subtitle2"><b>HELP SAVE YOURS</b></p>
<p class="author">ELIZABETH HARRIS</p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?06afd9f0